/* index.tsx generated by @compiled/babel-plugin v0.36.1 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "isDisabled"];
import "./index.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { forwardRef } from 'react';
import { Pressable } from '@atlaskit/primitives/compiled';
var styles = {
  button: "_1e0c1bgi",
  innerContainer: "_1e0c1nu9 _1y1m1u8q _16d9qvcn _k48p1wq8 _19bv12x7 _ca0qv77o _n3tdv77o _u5f312x7 _y3gn18uv _o5721btx _1nmz9jpi",
  enabled: "_syaz1fxt _80omtlke _bfhkm7j4 _irr315ej _1di6ip91",
  disabled: "_syaz1lh4 _80om13gf _bfhksyzs"
};
/**
 * Action button has to be a span for the overflow to work correctly
 */
export var ActionButton = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    isDisabled = _ref.isDisabled,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Pressable, _extends({}, props, {
    isDisabled: isDisabled,
    ref: ref
    // We need to reset Pressable fixed font size to allow inline card to inherit the font size
    // from parent component such as paragraph and heading
    ,
    style: {
      font: "inherit"
    },
    xcss: styles.button
  }), /*#__PURE__*/React.createElement("span", {
    tabIndex: isDisabled ? undefined : 0,
    className: ax([styles.innerContainer, isDisabled ? styles.disabled : styles.enabled])
  }, children));
});